/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordId } from "../../commons/types/RecordId";
export const AddRecordsToClipRequest = core.serialization.object({
    recordIds: core.serialization.list(RecordId),
});
